import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { 
  HomePage, 
  SignupPage, 
  LoginPage, 
  ProfilePage, 
  RequestServicePage, 
  TechnicianTrackingPage,
  TechnicianPage
} from './pages';
import { BottomNav, TopNav } from './components';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <TopNav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/request-service" element={<RequestServicePage />} />
            <Route path="/tracking" element={<TechnicianTrackingPage />} />
            <Route path="/technician" element={<TechnicianPage />} />
          </Routes>
          <BottomNav />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
